import {ReferralListFilterModel} from '../models/referral-list-filter.model';

export class GetReferralAction {
  static readonly type = '[Referrals] GetReferrals';
  constructor(public payload: {filter: ReferralListFilterModel}) {
  }
}
export class GetReferralTokenAction {
  static readonly type = '[Referral] GetReferralToken';
}
